import { CartUpdateEvent } from '@theme/events';

/**
 * Giữ tính toàn vẹn của bundle trong giỏ: nếu khách xoá 1 món của 1 bundle
 * (các line cùng `_bundle_id`), thì xoá luôn các món còn lại của bundle đó
 * — giống druids. Chạy toàn site (load trong theme.liquid) để áp dụng ở cart drawer/cart page.
 */

let enforcing = false;

async function enforceBundles() {
  if (enforcing) return;
  enforcing = true;
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

    const groups = {};
    for (const item of cart.items) {
      const bid = item.properties && item.properties._bundle_id;
      if (!bid) continue;
      (groups[bid] = groups[bid] || []).push(item);
    }

    const updates = {};
    for (const bid in groups) {
      const lines = groups[bid];
      const expected = parseInt(lines[0].properties._bundle_count || '0', 10);
      // Thiếu món so với lúc tạo bundle -> xoá nốt phần còn lại.
      if (expected && lines.length < expected) {
        for (const line of lines) updates[line.key] = 0;
      }
    }

    if (Object.keys(updates).length === 0) return;

    const updated = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    }).then((r) => r.json());

    // Làm mới UI giỏ (cart drawer / cart page tự render lại khi nhận cart:update).
    document.dispatchEvent(
      new CartUpdateEvent(updated, 'bundle-cart', { source: 'bundle-cart', itemCount: updated.item_count })
    );
  } catch {
    /* bỏ qua, lần cập nhật sau thử lại */
  } finally {
    enforcing = false;
  }
}

document.addEventListener('cart:update', enforceBundles);

/**
 * Nút "Remove bundle" trong giỏ: xoá TẤT CẢ line item cùng `_bundle_id`.
 * Dùng event-delegation ở document để vẫn bắt được sau mỗi lần cart re-render.
 */
let removingBundle = false;
async function removeBundle(bundleId, btn) {
  if (removingBundle || !bundleId) return;
  removingBundle = true;

  // Lấy line key + các dòng cần ẩn TỪ DOM (giỏ đã render sẵn) -> KHỎI phải fetch /cart.js (tiết kiệm ~1 request).
  const updates = {};
  const rows = [];
  if (btn) {
    const header = btn.closest('tr') || btn.closest('[data-bundle-header]');
    if (header) rows.push(header);
  }
  document.querySelectorAll('[data-bundle-id="' + (window.CSS && CSS.escape ? CSS.escape(bundleId) : bundleId) + '"]').forEach((el) => {
    const row = el.closest('tr') || el;
    rows.push(row);
    const keyEl = el.hasAttribute('data-key') ? el : el.closest('[data-key]');
    const key = keyEl && keyEl.getAttribute('data-key');
    if (key) updates[key] = 0;
  });

  // Phản hồi TỨC THÌ: ẩn ngay các dòng của bundle (giỏ sẽ render lại sau khi cập nhật xong).
  rows.forEach((r) => { r.style.display = 'none'; });

  try {
    let body = { updates };
    // Fallback: không lấy được key từ DOM -> mới phải đọc /cart.js.
    if (Object.keys(updates).length === 0) {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const u = {};
      for (const item of cart.items) {
        if (item.properties && item.properties._bundle_id === bundleId) u[item.key] = 0;
      }
      if (Object.keys(u).length === 0) { rows.forEach((r) => { r.style.display = ''; }); return; }
      body = { updates: u };
    }

    const updated = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

    document.dispatchEvent(
      new CartUpdateEvent(updated, 'bundle-cart', { source: 'bundle-cart', itemCount: updated.item_count })
    );
  } catch {
    rows.forEach((r) => { r.style.display = ''; }); // lỗi -> hiện lại để khách thử lại
  } finally {
    removingBundle = false;
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-bundle-remove]');
  if (!btn) return;
  e.preventDefault();
  removeBundle(btn.getAttribute('data-bundle-remove'), btn);
});
